import { type DatabaseChangeType } from '@databases/types/redux';

import {
  TABLE_VIEW_HARD_COLUMN_MIN_WIDTH,
  TABLE_VIEW_COLUMN_WIDTH_COMMENTS_BUFFER
} from '../../../../constants.ts';
import { getValueId } from '../../../../utils.ts';
import { type YJSChangeHandler } from '../../types.ts';

export const addValueCommentThread: YJSChangeHandler<
  DatabaseChangeType.ADD_VALUE_COMMENT_THREAD
> = ({ ydb, change }) => {
  ydb.mutate((db) => {
    db.addCommentThread(getValueId(change.entryId, change.fieldId), change.newThread);

    const fieldWidth = db.fieldsById[change.fieldId].width;
    if (fieldWidth) {
      db.fieldsById[change.fieldId].width = Math.max(
        fieldWidth,
        TABLE_VIEW_HARD_COLUMN_MIN_WIDTH + TABLE_VIEW_COLUMN_WIDTH_COMMENTS_BUFFER
      );
    }
  });
};
